// @flow

/**
 * @module Constants/EsignModification
 * @desc EsignModification Constants
 */

import keyMirror from 'keymirror';

/**
 * @constant {Object} EsignModificationConstants
 * @memberof EsignModification
 */
export const EsignModificationConstants = keyMirror({
  FETCH_CONTRACT_MODIFICATION: undefined,
  FETCH_SETTLEMENT_MODIFICATION: undefined,
  FETCH_SCRA_WAIVER: undefined,
  ESIGN_CONTRACT_MODIFICATION: undefined,
  ESIGN_SETTLEMENT_MODIFICATION: undefined,
  ESIGN_SCRA_WAIVER: undefined,
});
